import { type SelectOption } from '../../../../components';

export enum DsrcApprovalDecision {
  ACCEPT = 'ACCEPT',
  RETURN = 'RETURN',
  NA = 'NA',
}

export const dsrcApprovalDecisionOptions: SelectOption[] = [
  { label: 'approve', value: DsrcApprovalDecision.ACCEPT },
  { label: 'do not approve', value: DsrcApprovalDecision.RETURN },
];
